export default __webpack_public_path__ + "assets/corner-down-right.svg";